"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ajv = void 0;
// Initialize Ajv instance and define custom keywords
const ajv_1 = __importDefault(require("ajv"));
const ajv_formats_1 = __importDefault(require("ajv-formats"));
const dayjs_1 = __importDefault(require("dayjs"));
const ajv_errors_1 = __importDefault(require("ajv-errors"));
const ajv = new ajv_1.default({ allErrors: true, useDefaults: true });
exports.ajv = ajv;
(0, ajv_errors_1.default)(ajv);
ajv.addFormat("autocomplete", {
    type: "string",
    validate: x => true,
});
ajv.addFormat("icd10-autocomplete", {
    type: "string",
    validate: x => true,
});
ajv.addFormat("lab-tests-autocomplete", {
    type: "string",
    validate: x => true,
});
// Add support for formats and format comparison keywords
(0, ajv_formats_1.default)(ajv);
ajv.addKeyword({
    keyword: "disablePast",
    type: "number",
    schemaType: "boolean",
    validate: (schema, data) => {
        if (schema) {
            const todayTimestamp = (0, dayjs_1.default)().startOf("day").valueOf();
            return data >= todayTimestamp;
        }
        return true; // If schema is false, validation passes
    },
    error: {
        message: "The date must be in the future.",
    },
});
ajv.addKeyword({
    keyword: "disableFuture",
    type: "number",
    schemaType: "boolean",
    validate: (schema, data) => {
        if (schema) {
            const todayTimestamp = (0, dayjs_1.default)().startOf("day").valueOf();
            return data <= todayTimestamp;
        }
        return true; // If schema is false, validation passes
    },
    error: {
        message: "The date must be in the past.",
    },
});
ajv.addKeyword({
    keyword: "validateTimeRange",
    type: "object",
    schemaType: "boolean",
    validate: (_, data, parentSchema) => {
        var _a, _b;
        const isDisablePast = (_a = parentSchema === null || parentSchema === void 0 ? void 0 : parentSchema.properties.visitDate) === null || _a === void 0 ? void 0 : _a.disablePast;
        const isDisableFuture = (_b = parentSchema === null || parentSchema === void 0 ? void 0 : parentSchema.properties.visitDate) === null || _b === void 0 ? void 0 : _b.disableFuture;
        if ((isDisablePast || isDisableFuture) &&
            data.visitStartTime &&
            data.visitEndTime) {
            const currentDate = (0, dayjs_1.default)().startOf("day").valueOf();
            const currentTime = (0, dayjs_1.default)().valueOf();
            if (data.visitDate === currentDate) {
                if (isDisablePast &&
                    (data.visitStartTime < currentTime || data.visitEndTime < currentTime)) {
                    return false;
                }
                if (isDisableFuture &&
                    (data.visitStartTime > currentTime || data.visitEndTime > currentTime)) {
                    return false;
                }
            }
            if (data.visitStartTime >= data.visitEndTime) {
                return false;
            }
        }
        return true;
    },
    error: {
        message: "The time range is not valid",
    },
});
ajv.addKeyword({
    keyword: "maxOneIDPanelPerRequisition",
    type: "array",
    schemaType: "boolean",
    validate: function validate(schema, data, context) {
        if (!Array.isArray(data)) {
            return true;
        }
        const infectiousDiseases = data
            .map((test, index) => ({
            index,
            test,
        }))
            .filter(i => {
            var _a;
            return ((_a = i.test) === null || _a === void 0 ? void 0 : _a.labTest) &&
                JSON.parse(i.test.labTest).panelType === "Infectious Disease";
        });
        if (infectiousDiseases.length > 1) {
            validate.errors = infectiousDiseases.map(id => ({
                instancePath: `/tests/${id.index}/labTest`,
                schemaPath: "#/properties/tests/maxOneIDPanelPerRequisition",
                keyword: "maxOneIDPanelPerRequisition",
                params: {},
                message: "Max one infectious disease panel allowed per requistion",
            }));
            return false;
        }
        validate.errors = [];
        return true;
    },
});
ajv.addKeyword({
    keyword: "noBloodAndIDTogether",
    type: "array",
    schemaType: "boolean",
    validate: function validate(schema, data, context) {
        if (!Array.isArray(data)) {
            return true;
        }
        const panelTypes = data
            .filter(test => !!(test === null || test === void 0 ? void 0 : test.labTest))
            .map(test => JSON.parse(test.labTest).panelType);
        const uniquePanelTypes = new Set(panelTypes);
        if (uniquePanelTypes.size > 1) {
            validate.errors = [
                {
                    instancePath: `/tests/`,
                    schemaPath: "#/properties/tests/noBloodAndIDTogether",
                    keyword: "noBloodAndIDTogether",
                    params: {},
                    message: "Blood and Infectious Disease panel cannot be together",
                },
            ];
            return false;
        }
        validate.errors = [];
        return true;
    },
});
ajv.removeKeyword("required");
ajv.addKeyword({
    keyword: "required",
    type: "object",
    schemaType: "array",
    validate: function validate(requiredFields, data, _parentSchema, dataCxt) {
        const basePath = (dataCxt === null || dataCxt === void 0 ? void 0 : dataCxt.instancePath) || "";
        const errors = [];
        for (const field of requiredFields) {
            const value = data[field];
            if (value === undefined ||
                value === null ||
                (typeof value === "string" && value.trim() === "")) {
                errors.push({
                    instancePath: basePath,
                    keyword: "required",
                    params: { missingProperty: field },
                    message: `must have required property '${field}'`,
                    schemaPath: "#/required",
                });
            }
        }
        if (errors.length > 0) {
            validate.errors = errors;
            return false;
        }
        return true;
    },
});
